<app-grid-simmer *ngIf="shimmerStatus.continueWatching"></app-grid-simmer>
<section
  class="series-slider"
  *ngIf="!shimmerStatus.continueWatching"
  (mouseenter)="playOff()"
>
  <div class="container">
    <div id="popular" class="section-head">
      <h2>{{ "HOME.Continue_Watching" | translate }}</h2>
      <a
        *ngIf="continueWatchingData.length > 1"
        (click)="deleteContinueWatching('clear_all')"
        class="view-all-link cursor-pointer"
      >
        {{ "HOME.CLEAR_ALL" | translate }}
      </a>
    </div>
    <div class="slider" id="slider-top">
      <owl-carousel-o [options]="upcomingShow">
        <ng-container *ngFor="let continue of continueWatchingData">
          <ng-template carouselSlide [id]="continue?.public_id">
            <div class="series-box">
              <app-grid
                [data]="continue"
                [gridType]="'landscape'"
                [watchingStatus]="true"
                [status]="'Continue_Watching'"
              ></app-grid>
            </div>
          </ng-template>
        </ng-container>
      </owl-carousel-o>
    </div>
  </div>
</section>
